<ng-container *ngIf="description">
  <div class="hd">
    <p class="hd-text">
      {{ description.text }}
      <span class="hd-beta" *ngIf="description.beta !== false" title="New: written by PlateX and still being checked">Beta</span>
    </p>
    <button type="button" class="hd-report" (click)="openReport($event)">Seen an error?</button>
  </div>

  <div class="hd-backdrop" *ngIf="open" (click)="close()"></div>
  <div
    #dialog
    class="hd-dialog"
    *ngIf="open"
    role="dialog"
    aria-modal="true"
    aria-labelledby="hd-title"
  >
    <button type="button" class="hd-x" (click)="close()" aria-label="Close">&times;</button>

    <ng-container *ngIf="!sent; else thanks">
      <h2 id="hd-title" class="hd-title">Report an error</h2>
      <p class="hd-lead">What is wrong with this description of {{ displayRegistration || registration }}?</p>

      <form (ngSubmit)="send()" novalidate>
        <div class="hd-reasons" role="radiogroup" aria-label="Reason" [attr.aria-invalid]="error && !reason ? 'true' : null">
          <button
            type="button"
            *ngFor="let r of reasons"
            class="hd-reason"
            role="radio"
            [attr.aria-checked]="reason === r.key"
            [class.is-on]="reason === r.key"
            (click)="pick(r.key)"
          >{{ r.label }}</button>
        </div>

        <label class="hd-field">
          <span class="hd-label">Tell us more <span class="hd-opt">(optional)</span></span>
          <textarea class="hd-input" rows="3" maxlength="500" [(ngModel)]="comment" name="comment"></textarea>
        </label>

        <label class="hd-field">
          <span class="hd-label">Email <span class="hd-opt">(optional, if you'd like a reply)</span></span>
          <input class="hd-input" type="email" autocomplete="email" maxlength="254" [(ngModel)]="email" name="email" />
        </label>

        <!-- Honeypot: hidden from people, left empty; bots that fill it are dropped server side. -->
        <div class="hd-hp" aria-hidden="true">
          <label>Website <input type="text" tabindex="-1" autocomplete="off" [(ngModel)]="website" name="website" /></label>
        </div>

        <p class="hd-error" *ngIf="error" role="alert">{{ error }}</p>

        <button type="submit" class="hd-send" [disabled]="sending">{{ sending ? 'Sending' : 'Send' }}</button>
      </form>
    </ng-container>

    <ng-template #thanks>
      <h2 id="hd-title" class="hd-title">Thank you</h2>
      <p class="hd-lead">We'll check the description and correct it if needed.</p>
      <button type="button" class="hd-send" (click)="close()">Close</button>
    </ng-template>
  </div>
</ng-container>
